
$(document).ready(function () {
    $(".js-drawer-open-desktop-nav button").click(function () {
        $(".header__inline-menu").toggleClass("active");
    });
});

function myFunction() {
    var x = document.getElementById("myDIV"),
        y = document.getElementById("anotherDIV");
    x.style.display === "none" ? ((x.style.display = "block"), (y.style.display = "block")) : ((x.style.display = "none"), (y.style.display = "none"));
}

document.addEventListener("DOMContentLoaded", function () {
    var x = document.getElementById("myDIV"),
        y = document.getElementById("anotherDIV");
    (x.style.display = "none"), (y.style.display = "none");
}),
    jQuery(".footer-block--menu .footer-block__heading").click(function () {
        $(window).width() <= "749" &&
            (jQuery(this).hasClass("show")
                ? (jQuery(this).removeClass("show"), jQuery(this).next().slideUp())
                : (jQuery(".footer-block--menu .footer-block__heading").removeClass("show"), jQuery(".footer-block--menu .footer-block__heading").next().slideUp(), jQuery(this).addClass("show"), jQuery(this).next().slideDown()));
    });


$('.cus_img_slide_inner').slick({
  arros: true,
  infinite: false,
  autoplay: true,
  autoplaySpeed: 5000,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});



